import MedicalPlanDetails from "../details/medical-plan-details";
import { UserRoundIcon } from "lucide-react";
import NoPreviewCard from "../card/no-preview-card";

interface MedicalPlanProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    medicalPlanData: any | null;
    userId: string;
}

export const MedicalPlan = ({ medicalPlanData, userId }: MedicalPlanProps) => {
    return (
        <>
            {medicalPlanData ? (
                <MedicalPlanDetails patient={medicalPlanData} userId={userId} />
            ) : (
                <NoPreviewCard
                    Icon={UserRoundIcon}
                    title="No medical plan"
                    description="This patient does not have a medical plan yet."
                    cardTitle="Medical Plan"
                />
            )}
        </>
    );
}